// src/pages/Success.js
import React, { useEffect, useState, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import confetti from "canvas-confetti";
import { CartContext } from "../context/CartContext"; 
import "./Success.css";

const Success = () => {
  const location = useLocation();
  const [trackingNumber, setTrackingNumber] = useState("");
  const [sessionId, setSessionId] = useState("");
  const { clearCart } = useContext(CartContext); 
  const h1Ref = useRef(null);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const sessionId = query.get("session_id");
    setSessionId(sessionId);

    if (sessionId) {
      fetch("https://api.the-brik.com/get-payment-info/" + sessionId)
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "succeeded") {
            setTrackingNumber(data.customer_track_code);
            clearCart(); 
          } else {
            console.error("Payment not succeeded:", data);
          }
        })
        .catch((error) => console.error("Error fetching payment info:", error));
    }

    // 🎉 Trigger Confetti from h1 Text Position
    setTimeout(() => {
      if (h1Ref.current) {
        const rect = h1Ref.current.getBoundingClientRect();
        const originX = (rect.left + rect.width / 2) / window.innerWidth;
        const originY = (rect.top + rect.height / 2) / window.innerHeight;

        confetti({
          particleCount: 200,
          spread: 100,
          startVelocity: 40,
          origin: { x: originX, y: originY },
        });

      }
    }, 500); 

  }, [location.search]);

  return (
    <div>
      <Header />
      <div className="success-container">
        <h1 ref={h1Ref}>Order Confirmed!</h1> {/* Reference added */}
        <p>Thank you for your purchase.</p>
        <p>Your order has been confirmed and is being processed.</p>
        <p>You will receive an email shortly with your order details and tracking information.</p>
        <p>Please check your spam folder if you have not received it yet.</p>        {trackingNumber && (
          <p>Your tracking number is: <strong>{trackingNumber}</strong></p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Success;
